/*
* blazingcard
* http://www.blazingcard.com
*
* Copyright (c) 2022 Kellton Tech Pvt Ltd
* Author Kellton Tech Pvt Ltd <support@blazingcard.com>
* Licensed under the MIT license.
*/
import { Map, Record } from 'immutable';

export interface SalesLayoutState extends Map<string, any> {

  salesCount: any;
  salesCountLoading: boolean;
  salesCountLoaded: boolean;
  salesCountFailed: boolean;

}

export const SalesLayoutStateRecord = Record({

  salesCount: {},
  salesCountLoading: false,
  salesCountLoaded: false,
  salesCountFailed: false,

});
